export default __webpack_public_path__ + "static/media/B0006.b45f5053.png";